export default class AttendanceStatus {
  static readonly NORMAL = "normal";
  static readonly SUBMITTED = "submitted";
  static readonly UNSUBMITTED = "unsubmitted";
  static readonly REJECTED = "rejected";
  static readonly APPROVED = "approved";
}
